// socket.js
import { io } from "socket.io-client";

const socket = io("https://bpohasil.ngrok.app", {
  withCredentials: true,
  transports: ["websocket", "polling"],
});

export default socket;
